export default "__VITE_ASSET__ae96aa53__"